import json from "./en.json";

export const useTranslations = () => {
  return json as Record<string, string>;
}
